import styles from "./BankCard.module.scss";
import clsx from "clsx";

export default function BankCard({ children, dashed }) {
  return (
    <div className={clsx(styles.bankCard, dashed && styles.dashed)}>
      {children}
    </div>
  );
}
